'use client'

import React, { createContext, PropsWithChildren, useContext } from 'react'

import type { Env } from '@/lib/env'

const defaultEnv: Env = {
  APP_ENV: 'production',
  BUGSNAG_KEY: '',
  GA_TRACKING_ID: '',
  ORIGIN_COOKIE: 'mryum.origin',
  API_URL: '',
  BASE_URL: 'https://www.meandu.app',
  CLOUDFLARE_IMAGE_RESIZING_URL: 'https://www.mryum.com/cdn-cgi/image',
  REGION: 'ap1',
  STRIPE_KEY_AUD: '',
  STRIPE_KEY_NZD: '',
  STRIPE_KEY_USD: '',
  STRIPE_KEY_SGD: '',
  STRIPE_KEY_GBP: '',
  UNLEASH_SERVER_API_URL: '',
  UNLEASH_SERVER_API_TOKEN: '',
  GOOGLE_TAG_MANAGER_ID_SYD: '',
  GOOGLE_TAG_MANAGER_ID_PER: '',
  GOOGLE_PLACES_API_KEY: 'AIzaSyA8kTkrv_P9n9dcvkPQsHtAgn896ZllPJI',
  AMPLITUDE_KEY: '',
}

export const EnvContext = createContext<Env>(defaultEnv)

interface EnvProviderProps {
  env: Env
}

export const EnvProvider = ({
  env,
  children,
}: PropsWithChildren<EnvProviderProps>) => {
  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
}

export const useEnv = () => useContext(EnvContext)
